const getQueryParams = displayProperties => {
  const defaultParams = ['name', 'id'];
  if (!displayProperties || !displayProperties.adminLabel) return defaultParams;

  const { adminLabel } = displayProperties;

  const extraParams = Object.keys(adminLabel).flatMap(value => adminLabel[value]);

  const formattedParams = extraParams.map(param => {
    if (!param.includes('.')) return param;
    const [relation, property] = param.split('.');
    return `${relation} { ${property} }`;
  });

  const params = [...defaultParams, ...formattedParams];

  return params.filter((item, index) => params.indexOf(item) === index);
};

export default getQueryParams;
